import React, { useState, useEffect } from 'react';
import { FiRefreshCw } from 'react-icons/fi';

function CompanyInfo({ selectedCompany, apiBaseUrl, apiKey }) {
  const [companyInfo, setCompanyInfo] = useState(null);
  const [error, setError] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    if (selectedCompany) {
      fetchCompanyInfo();
    } else {
      setCompanyInfo(null);
      setError(null);
    }
  }, [selectedCompany]);

  const fetchCompanyInfo = async () => {
    try {
      const response = await fetch(`${apiBaseUrl}/company/${selectedCompany}`, {
        headers: {
          'X-Access-Token': process.env.REACT_APP_CONNECTOR_API_KEY
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch company info');
      }
      const data = await response.json();
      setCompanyInfo(data);
      setError(null);
    } catch (error) {
      console.error('Error fetching company info:', error);
      setError('Failed to fetch company information. Please try again.');
    }
  };

  const handleForceRefresh = async () => {
    try {
      setIsRefreshing(true);
      
      const aiEndpoint = process.env.REACT_APP_AI_ENDPOINT_URL;
      const response = await fetch(`${aiEndpoint}/update-company-instruction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          company_name: selectedCompany
        })
      });
      
      if (!response.ok) {
        throw new Error(`Server returned ${response.status}: ${response.statusText}`);
      }
      
    } catch (error) {
      console.error('Error refreshing instruction:', error);
      setError(`Failed to refresh instructions: ${error.message}`);
    } finally {
      setTimeout(() => {
        setIsRefreshing(false);
      }, 800);
    }
  };

  if (error) return <div className="text-red-500 mt-4">{error}</div>;
  if (!companyInfo) return null;

  return (
    <div className="mt-4">
      <h3 className="text-lg leading-6 font-medium text-gray-900">Company Information</h3>
      <dl className="mt-2 border-t border-b border-gray-200 divide-y divide-gray-200">
        <div className="py-3 flex justify-between text-sm font-medium">
          <dt className="text-gray-500">Name</dt>
          <dd className="text-gray-900">{companyInfo.name}</dd>
        </div>
        <div className="py-3 flex justify-between text-sm font-medium">
          <dt className="text-gray-500">Google Doc</dt>
          <dd className="text-gray-900">
            {companyInfo.gdoc_id ? (
              <a
                href={`https://docs.google.com/document/d/${companyInfo.gdoc_id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-indigo-600 hover:text-indigo-900"
              >
                View Document
              </a>
            ) : (
              'No document linked'
            )}
          </dd>
        </div>
        <div className="py-3 flex justify-between items-center text-sm font-medium">
          <dt className="text-gray-500">Refresh Instructions</dt>
          <dd>
            <button
              className={`px-4 py-2 bg-green-400 text-white rounded hover:bg-green-500 transition duration-300 flex items-center ${isRefreshing ? 'opacity-75' : ''}`}
              onClick={handleForceRefresh}
              disabled={isRefreshing}
            >
              <FiRefreshCw 
                className={`mr-2 ${isRefreshing ? 'animate-spin' : ''}`} 
              />
              {isRefreshing ? 'Refreshing...' : 'Force Refresh'}
            </button>
          </dd>
        </div>
      </dl>
    </div>
  );
}

export default CompanyInfo;
